import { useEffect } from 'react'

import { resolveSiteBrandMediaUrl } from '@/constants/site-brand'
import { useSiteBrand } from '@/hooks'

/** 同步 document.title 与 favicon */
export function SiteHead() {
  const { documentTitle, site } = useSiteBrand()

  useEffect(() => {
    document.title = documentTitle
  }, [documentTitle])

  useEffect(() => {
    const href = resolveSiteBrandMediaUrl(site.favicon_url)
    if (!href) return

    let link = document.querySelector<HTMLLinkElement>('link[rel*="icon"]')
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    link.href = href
  }, [site.favicon_url])

  return null
}
